import React, { Component } from "react";
import "./DataUseSlider.css";

import Slider from "rc-slider";
import "rc-slider/assets/index.css";

import MediaQuery from "react-responsive";

import IconGaming from "../../../../images/ic_data_use_gaming.png";
import IconMusic from "../../../../images/ic_data_use_music.png";
import IconSocialMedia from "../../../../images/ic_data_use_social_media.png";
import IconStreaming from "../../../../images/ic_data_use_streaming.png";

class DataUseSlider extends Component {
  constructor(props) {
    super(props);

    this.onChange = this.props.onChange;
    this.onAfterChange = this.props.onAfterChange;

  }

  render() {
    const defaultLargeDeviceMarkStyle = {
      color: "#FFFFFF",
      fontSize: "15px",
      marginTop: "10px",
      width: "max-content",
    };

    const defaultSmallDeviceMarkStyle = {
      color: "#FFFFFF",
      fontSize: "12px",
      marginTop: "10px",
      width: "max-content",
    };

    const { type } = this.props;

    if (type == null) return null;

    const lang = window.THREE_REACT_APP_GLOBAL.language;
    let icon, text;

    switch (type) {
      case "music":
        icon = IconMusic;
        text = lang === "tc" ? "串流音樂" : "Streaming music";
        break;
      case "social-media":
        icon = IconSocialMedia;
        text = lang === "tc" ? "社交媒體" : "Social media";
        break;
      case "streaming":
        icon = IconStreaming;
        text =
          lang === "tc"
            ? "串流電視、影片、電影"
            : "Streaming TV, video or movie";
        break;
      case "gaming":
        icon = IconGaming;
        text = lang === "tc" ? "玩手遊" : "Gaming on the go";
        break;
      default:
        break;
    }

    return (
      <div className="container-data-use-slider" style={this.props.style}>
        <MediaQuery minWidth={992}>
          <div className="wrapper-data-use-type">
            <img src={icon} width={24} height={24} />
            <span className="text">{text}</span>
          </div>

          <div className="wrapper-slider">
            <Slider
              className={lang}
              min={1}
              max={5.1}
              defaultValue={1}
              marks={{
                1: {
                  label: lang === "tc" ? "30" : "30",
                  style: defaultLargeDeviceMarkStyle,
                },
                2: {
                  label: lang === "tc" ? "60" : "60",
                  style: defaultLargeDeviceMarkStyle,
                },
                3: {
                  label: lang === "tc" ? "90" : "90",
                  style: defaultLargeDeviceMarkStyle,
                },
                4: {
                  label: lang === "tc" ? "120" : "120",
                  style: defaultLargeDeviceMarkStyle,
                },
                5: {
                  label: lang === "tc" ? "180+" : "180+",
                  style: defaultLargeDeviceMarkStyle,
                },
              }}
              railStyle={{
                height: "16px",
                borderRadius: "2rem",
              }}
              handleStyle={{
                height: "24px",
                width: "24px",
                boxShadow: "0px 0px 5px 0px #00000080",
                borderColor: "#FFFFFF",
              }}
              trackStyle={{
                height: "16px",
                width: "16px",
                border: 0,
                backgroundColor: "#7356D9",
              }}
              dotStyle={{
                display: "none",
              }}
              maximumTrackStyle={{

              }}
              step={null}
              onChange={(value) => this.onChange(value)}
              onAfterChange={(value)=>this.onAfterChange(value)}
            />
          </div>
        </MediaQuery>

        <MediaQuery maxWidth={991.98}>
          <div className="wrapper-data-use-type">
            <img src={icon} width={20} height={20} />
            <span className="text">{text}</span>
          </div>

          <div className="wrapper-slider">
            <Slider
              style={{ marginLeft: "10px" }}
              className={lang}
              min={1}
              max={5.15}
              defaultValue={1}
              marks={{
                1: {
                  label: lang === "tc" ? "30" : "30",
                  style: defaultSmallDeviceMarkStyle,
                },
                2: {
                  label: lang === "tc" ? "60" : "60",
                  style: defaultSmallDeviceMarkStyle,
                },
                3: {
                  label: lang === "tc" ? "90" : "90",
                  style: defaultSmallDeviceMarkStyle,
                },
                4: {
                  label: lang === "tc" ? "120" : "120",
                  style: defaultSmallDeviceMarkStyle,
                },
                5: {
                  label: lang === "tc" ? "180+" : "180+",
                  style: defaultSmallDeviceMarkStyle,
                },
              }}
              railStyle={{
                height: "16px",
                borderRadius: "2rem",
              }}
              handleStyle={{
                height: "24px",
                width: "24px",
                boxShadow: "0px 0px 5px 0px #00000080",
                borderColor: "#FFFFFF",
              }}
              trackStyle={{
                height: "16px",
                width: "16px",
                border: 0,
                backgroundColor: "#7356D9",
              }}
              dotStyle={{
                display: "none",
              }}
              step={null}
              onChange={(value) => this.onChange(value)}
              onAfterChange={(value)=>this.onAfterChange(value)}
            />
          </div>
        </MediaQuery>
      </div>
    );
  }
}

export default DataUseSlider;
